import Quote from "./quote";

export default Quote;
